import { Component, OnInit, Input, Output, EventEmitter, Optional, Inject, ViewChild, OnChanges } from '@angular/core';
import {
  CheckInterviewSchDataObj,
  ServiceLine,
  DataIds,
  ITemplate,
  InterviewActivity,
  ISnackbarData,
  CorrespondenceDataObj,
  Venue,
  Template,
  ISaveInterviewActivity,
  ISaveCorrespondenceActivity,
} from 'src/app/shared/models/activity-dashboard-model';
import { ActivityService } from 'src/app/core/services/activity.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { FileService } from '../../../core/services/file.service';
import { ActivityCorrespondenceComponent } from '../activity-correspondence/activity-correspondence.component';
import { ActivityDialogComponent } from '../activity-dialog/activity-dialog.component';
import { SchedulerCandidate, ActivitiesOnCandidate } from '../../../shared/models/schedulerAssociate';
import { DatePipe } from '@angular/common';
import { AssociateService } from '../../schedulerpersona/services/associate.service';

@Component({
  selector: 'activity-scheduleinterview',
  templateUrl: './activity-scheduleinterview.component.html',
  styleUrls: ['./activity-scheduleinterview.component.scss'],
  standalone: false,
})
export class ActivityScheduleinterviewComponent implements OnInit, OnChanges {
  // file upload
  allowedTypes = '.doc,docx,.xls,xlsx,.pdf,.jpg,.jpeg,.msg,.png';
  multiple = 'multipleSelect';
  fileDemoData: any;
  single = 'single';
  editId: any;
  fileData: any;
  deletedFile: any;
  companyHiringType: any; //= 1;
  snackbarData: ISnackbarData;

  sendMailCheck: boolean = false;
  mailFlag: boolean = false;
  public isCollapsed: boolean = false;
  //time
  public timeModifiedOn: string;
  @Output() refreshcandiates: EventEmitter<any> = new EventEmitter();

  @ViewChild(ActivityCorrespondenceComponent) corresActivity: ActivityCorrespondenceComponent;
  // @ViewChildren(ActivityCorrespondenceComponent) corresActivity: <ActivityCorrespondenceComponent>;
  // @Input() interviewSIActivityNames:string[];

  public ccEnable: boolean = false;
  public bccEnable: boolean = false;
  template: Template[];
  templateDisable: boolean = false;
  toDisable: boolean = false;
  ccInputValue: string = null;
  bccInputValue: string = null;
  toInputValue: string;
  subjectInputValue: string;
  bodyInputValue: string;
  remarksInputValue: string;

  inputVal: string;
  inputValRemarks: string;
  ids: DataIds;
  notes: string;
  startDate: string;
  endDate: string;
  startTime: any; //number;
  endTime: number;
  //VenueId: number;
  deleteMsg: string;
  saveMsg: string;
  start: string;
  end: string;
  @Input() candidateApplicationIds: number[];
  editactivity: any = false;
  templateData: ITemplate[];
  InterviewTemplateData: ITemplate[];
  templateObj: ITemplate;
  userloggedin: any;
  loginUserName: any;
  interviewTime: any;
  interviewDate: any;
  minDate: Date;
  selectedClauseId: number;
  sendDisable: boolean;
  tempReq: boolean;
  role: string;
  hideFieldsForRecruiter: boolean = false;
  isNotesInExpectedFormat: boolean = false;
  addEvent1(event: MatDatepickerInputEvent<Date>) {
    this.startDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    console.log(this.startDate);
    this.interviewDate = this.datePipe.transform(new Date(this.startDate), 'dd-MM-yyyy');
    // this.minDate=new Date(Date.now());
    // console.log(this.minDate)
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
    this.endDate = this.datePipe.transform(event.value, 'yyyy-MM-dd');
    console.log(this.endDate);
  }
  select(startTime) {
    console.log('starttime selected', startTime);
    // console.log(typeof startTime);
    this.interviewTime = startTime;
    // let timestring= startTime[0] + startTime[1] + startTime[3] + startTime[4];
    console.log('array--0134--', startTime[0], startTime[1], startTime[3], startTime[4]);
    this.startTime = +(startTime[0] + startTime[1] + startTime[3] + startTime[4]);
    // console.log(typeof this.startTime, this.startTime);
    // this.startTime=Number(timestring);
    console.log(typeof this.startTime, this.startTime);
  }
  // select1(endTime) {
  //   this.endTime = +(endTime.slice(0, 2) + endTime.slice(3));
  //   console.log(this.endTime);

  // }

  @Input() checkInterviewSchDataObj: CheckInterviewSchDataObj;
  @Input() ifCoupled: boolean;
  @Input() candidateEmails: string[];
  @Input() selectedCandidate: SchedulerCandidate[];

  serviceLine: ServiceLine[];

  venue: Venue[];
  selectedVenue: Venue;

  templates: Template[];
  toggleBtn: boolean = false;

  isDeleteDisable: boolean = true;
  candidateData: ActivitiesOnCandidate;
  correspondenceDataObj: CorrespondenceDataObj;

  @Input() interviewFlag: boolean;
  selectedTemplate: any;
  selectedClauseIndex: any;
  VenueId: any;
  placeholderMappingInterview: any[] = [];
  venueHide: boolean = false;
  @Output() singleformValid: EventEmitter<boolean> = new EventEmitter();
  testScoreData: any = null;

  constructor(
    private interviewService: ActivityService,
    private fileService: FileService,
    private associateService: AssociateService,
    private datePipe: DatePipe,
    public dialogRef: MatDialogRef<ActivityDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.minDate = new Date(Date.now());
    if (data) {
      this.checkInterviewSchDataObj = data.checkInterviewSchDataObj;
      this.editactivity = data.editActivity;
      this.isCollapsed = data.editActivity;
      this.candidateEmails = data.candidateEmails;
      this.interviewFlag = data.interviewFlag;
    }
  }

  ccEnableDisable() {
    console.log(this.ccEnable);
    this.ccEnable = !this.ccEnable;
    console.log(this.ccEnable);
  }
  bccEnableDisable() {
    this.bccEnable = !this.bccEnable;
  }
  ngOnChanges() {
    this.notes = '';
    this.startDate = '';
    this.endDate = '';

    this.startTime = null;
    this.endTime = null;

    this.selectedVenue = null;
    this.selectedTemplate = -1;
    console.log('interviewflag----', this.interviewFlag);
    if (this.interviewFlag) {
      this.templateDisable = true;
      console.log('selectedclause---', this.selectedClauseIndex);
      if (this.selectedClauseIndex >= 0) {
        // let p =this.displayText(this.InterviewTemplateData[this.selectedClauseIndex].templateBody,0);
        this.bodyInputValue = this.templateData[this.selectedClauseIndex].templateBody;
        this.subjectInputValue = this.templateData[this.selectedClauseIndex].templateSubject;
      }
    }
  }
  testformValid(flag) {
    // console.log('single form working', flag);
    this.singleformValid.emit(flag);
  }

  ngOnInit() {
    this.isCollapsed = true;

    //this.getActivity()
    console.log('int falg--', this.interviewFlag);
    this.companyHiringType = localStorage.getItem('fresherCompHiringTypeId');
    this.role = localStorage.getItem('role');
    const activityId = Number(this.checkInterviewSchDataObj.activityId);
    this.hideFieldsForRecruiter =
      (this.role === 'Recruiter' || this.role === 'DB Admin') &&
      this.companyHiringType === '2' &&
      activityId === 400104;
    //placeholder changes
    //  if(!this.editactivity)
    //  {

    //     this.selectedCandidate.forEach(value=>{

    //       this.associateService.getActivitiesOnCandidate(value.applicationId,value.candidateId).subscribe(data=>
    //         {
    //           console.log("placeholder",data);
    //           this.candidateData=data;

    //           let obj=
    //             {

    //             fname:this.candidateData.fname,
    //             lname:this.candidateData.lname,
    //             candidateId:value.candidateId,

    //               //this.correspondenceDataObj.candidateName
    //             }
    //             this.placeholderMappingInterview.push(obj);

    //         })

    //       });
    //     }
    //     else{

    //       this.associateService.getActivitiesOnCandidate(this.checkInterviewSchDataObj.applicationId,this.checkInterviewSchDataObj.candidateId).subscribe(data=>
    //         {
    //           console.log("placeholder",data);
    //           this.candidateData=data;

    //           let obj=
    //             {

    //             fname:this.candidateData.fname,
    //             lname:this.candidateData.lname,
    //             candidateId:this.checkInterviewSchDataObj.candidateId,

    //               //this.correspondenceDataObj.candidateName
    //             }
    //             this.placeholderMappingInterview.push(obj);

    //         })
    //     }
    //placeholder chnages end
    this.userloggedin = JSON.parse(localStorage.getItem('loggedInUser'));
    console.log('loginuser---->', this.userloggedin);

    this.loginUserName = this.userloggedin.username;
    console.log(this.loginUserName);
    console.log(this.candidateEmails);
    this.toInputValue = this.candidateEmails[0];
    this.toDisable = true;

    const activityNameCheck: string = this.checkInterviewSchDataObj.activityName.toLowerCase();
    if (
      activityNameCheck.includes('telephon') ||
      activityNameCheck.includes('skype') ||
      this.checkInterviewSchDataObj.activityId == 400103 ||
      this.checkInterviewSchDataObj.activityId == 400102 ||
      this.checkInterviewSchDataObj.activityId == 400105
    ) {
      this.venueHide = true;
    }
    this.notes = '';
    this.startDate = '';
    this.endDate = '';

    this.startTime = null;
    this.endTime = null;

    this.selectedVenue = null;
    this.selectedTemplate = -1;
    // this.editId = { objectId: this.checkInterviewSchDataObj.applicationId, objectType: 'AP' };

    // this.interviewService.getServiceLine().subscribe(data => {
    //   console.log(data);
    //   this.serviceLine = data;
    //   console.log(this.serviceLine);
    // })

    this.correspondenceDataObj = {
      isVisible: true,
      candidateName: this.checkInterviewSchDataObj.candidateName,
      activityName: this.checkInterviewSchDataObj.activityName, //hardcode
      applicationId: this.checkInterviewSchDataObj.applicationId,
      processId: this.checkInterviewSchDataObj.processId,
      activityId: this.checkInterviewSchDataObj.activityId, //hardcode
      // statusId: this.checkInterviewSchDataObj.statusId,
      candidateId: this.checkInterviewSchDataObj.candidateId,
      //hardcode
    };

    // this.dataInitialization(this.checkInterviewSchDataObj.interviewActivity);

    if (!this.editactivity) {
      this.interviewService.getVenue().subscribe((data) => {
        this.venue = data;
        console.log('venue---', data);
        console.log(this.venue);
      });
      if (
        this.checkInterviewSchDataObj &&
        this.checkInterviewSchDataObj.activityId &&
        this.checkInterviewSchDataObj.processId
      ) {
        this.interviewService
          .getTemplate(this.checkInterviewSchDataObj.activityId, this.checkInterviewSchDataObj.processId)
          .subscribe((data) => {
            // this.templates=data
            this.templateData = data;
            this.templateData = data;
            console.log('template-----', data);
          });
      }
    }

    if (this.editactivity) {
      // let activityid:any=this.checkInterviewSchDataObj.activityId;
      this.editId = {
        objectId: this.checkInterviewSchDataObj.applicationId,
        objectType: 'AP',
        activityId: this.checkInterviewSchDataObj.activityId,
      };
      console.log('editid=', this.editId);
      this.interviewService.getVenue().subscribe((data) => {
        this.venue = data;
        console.log('venue---', data);
        console.log(this.venue);
        if (
          this.checkInterviewSchDataObj &&
          this.checkInterviewSchDataObj.activityId &&
          this.checkInterviewSchDataObj.processId
        ) {
          this.interviewService
            .getTemplate(this.checkInterviewSchDataObj.activityId, this.checkInterviewSchDataObj.processId)
            .subscribe((data) => {
              // this.templates=data
              this.templateData = data;
              this.templateData = data;
              this.getActivity(this.checkInterviewSchDataObj);
              console.log('template-----', data);
            });
        }
      });
      // this.getActivity(this.checkInterviewSchDataObj);
    }
  }

  getTemplateData(event) {
    console.log(event);
    const index = this.templateData.findIndex((item) => item.clauseid === event.value);
    console.log(index);
    this.selectedClauseIndex = index;
    if (this.sendMailCheck) {
      this.sendDisable = false;
    }
    this.selectedClauseIndex = this.templateData.findIndex((item) => item.clauseid === event.value);
    this.selectedClauseId = this.templateData[this.selectedClauseIndex].templateId;
    console.log('templateid--', this.selectedClauseIndex, 'clauseid--', this.selectedTemplate);
    // let p =this.displayText(this.templateData[this.templateIndex].templateBody,0);
    // let p1=this.displayText("my name is <<fname>> and i live in city <<city>>")
    // this.bodyInputValue=p;
    this.bodyInputValue = this.templateData[this.selectedClauseIndex].templateBody;
    this.subjectInputValue = this.templateData[this.selectedClauseIndex].templateSubject;
  }
  saveInterviewCorresActivity(processId, activityId, applicationId) {
    console.log(this.ccInputValue);
    console.log('inside saveInterview correspondence');

    // console.log(fd)

    console.log(this.candidateEmails);

    this.associateService.recruiterActivity.subscribe((_res) => {
      if (this.editactivity) {
        const applicatonIDs: any[] = [];
        applicatonIDs.push(applicationId);
        const postDataObj: ISaveCorrespondenceActivity = {
          applicationIds: applicatonIDs,
          processId: 40,
          activityId: 400201,
          comments: this.remarksInputValue,
          clause_id: this.selectedTemplate,
          mailerID: 1010,
          // "clausMasterList": null,
          cc: this.ccInputValue,
          bcc: this.bccInputValue,
          templateId:
            this.templateData[this.templateData.findIndex((item) => item.clauseid === this.selectedTemplate)]
              .templateId,
          mobileRequest: false,
          eventId: null,
          templateSubject: this.subjectInputValue,
          templateBody: this.bodyInputValue,
        };
        console.log('savecoress obj for interview---', postDataObj);
        if (postDataObj && postDataObj.applicationIds && postDataObj.activityId && postDataObj.processId) {
          this.interviewService.saveCorrespondenceActivity(postDataObj).subscribe((res) => {
            console.log(res);
          });
        }
      } else {
        const applicatonIDs = this.candidateApplicationIds;
        const postDataObj: ISaveCorrespondenceActivity = {
          applicationIds: applicatonIDs,
          processId: 40,
          activityId: 400201,
          comments: this.remarksInputValue,
          clause_id: this.selectedTemplate,
          mailerID: 1010,
          // "clausMasterList": null,
          cc: this.ccInputValue,
          bcc: this.bccInputValue,
          templateId: this.selectedClauseId,
          mobileRequest: false,
          eventId: null,
          templateSubject: this.subjectInputValue,
          templateBody: this.bodyInputValue,
        };
        console.log('savecoress obj for interview---', postDataObj);
        if (postDataObj && postDataObj.applicationIds && postDataObj.activityId && postDataObj.processId) {
          this.interviewService.saveCorrespondenceActivity(postDataObj).subscribe((res) => {
            console.log(res);
            if (!this.ifCoupled) {
              this.refreshcandiates.emit('true');
            }
          });
        }
      }
      // let postDataObj: ISaveCorrespondenceActivity = {

      //   "applicationIds": applicatonIDs,
      //   "processId": res.interviewMail.processId,
      //   "activityId": res.interviewMail.activityId,
      //   "comments": this.remarksInputValuecorres,
      //   "clause_id": this.selectedTemplate,
      //   "mailerID": 1010,
      //   "clausMasterList": null,
      //   "cc": this.ccInputValue,
      //   "templateId":this.selectedClauseId,
      //   "mobileRequest": false,
      //   "eventId" : null,

      //   "templateBody":this.bodyInputValue

      // };
      // console.log("savecoress obj for interview---",postDataObj);
      // this.interviewService.saveCorrespondenceActivity(postDataObj).subscribe(res=>
      //   {
      //     console.log(res);
      //   })
    });
    //mailer integration
    // for(let i =0;i<this.candidateEmails.length;i++){

    //   console.log("index of mail-->",i);
    // const fd = new FormData();
    // fd.append('from', 'talentacquisition@infosys.com')
    // fd.append('subject', this.subjectInputValue);

    // if (this.ccInputValue != null) {
    //   fd.append('ccArray', this.ccInputValue)
    // }

    // if (this.fileData != null) {
    //   this.fileData.forEach(file => {
    //     fd.append('file[' + file.name + ']', file);

    //   });
    // }
    //   fd.append('to', this.candidateEmails[i]);
    //   let p =this.displayText( this.InterviewTemplateData[this.selectedClauseIndex].templateBody,i);
    //   fd.append('body',p)

    //   this.activityService.sendEmail(fd).subscribe(
    //     (res) => {
    //       console.log(res);
    //     },
    //     (err) => {
    //       console.log(err)
    //     }
    //   )
    // }
    //mailer integration ends
  }

  sendMailEnable() {
    console.log(this.sendMailCheck);
    console.log('selectedclause---', this.selectedClauseIndex);

    // this.sendMailCheck = !this.sendMailCheck;
    if (this.sendMailCheck && this.selectedTemplate == -1) {
      this.sendDisable = true;
    } else {
      this.sendDisable = false;
    }

    if (this.sendMailCheck) {
      this.tempReq = true;
    } else {
      this.tempReq = false;
    }

    if (this.editactivity) {
      this.templateDisable = true;
      console.log('selectedclause---', this.selectedClauseIndex);
      if (this.selectedClauseIndex >= 0) {
        // let p =this.displayText(this.InterviewTemplateData[this.selectedClauseIndex].templateBody,0);

        this.bodyInputValue = this.templateData[this.selectedClauseIndex].templateBody;
        this.subjectInputValue = this.templateData[this.selectedClauseIndex].templateSubject;
      }
    }
  }

  // expand/collapse action
  showMoreLess() {
    this.isCollapsed = !this.isCollapsed;
  }

  // Mock function to get data from input field.
  send() {
    console.log(this.startDate);
    let venueID: any;

    this.ids = this.interviewService.getDataIds();
    if (this.venueHide || this.hideFieldsForRecruiter) {
      venueID = null;
    } else {
      venueID = this.selectedVenue.venueId;
    }
    if (this.editactivity) {
      let tempTimeString;
      if (typeof this.startTime === 'string' && this.startTime.includes(':')) {
        const tempTime = this.startTime.split(':');
        tempTimeString = Number(tempTime[0] + tempTime[1]);
      } else {
        tempTimeString = Number(this.startTime);
      }

      // let startTime = +(this.startTime[0] + this.startTime[1] + this.startTime[3] + this.startTime[4]);
      const obj: InterviewActivity = {
        applicationIds: this.checkInterviewSchDataObj.applicationId,
        processID: this.checkInterviewSchDataObj.processId,
        activityID: this.checkInterviewSchDataObj.activityId,
        notes: this.notes,
        startDate: this.startDate,
        endDate: this.endDate,
        startTime: this.hideFieldsForRecruiter ? null : tempTimeString,
        endTime: this.endTime,
        // statusId: this.checkInterviewSchDataObj.statusId,
        venueId: this.hideFieldsForRecruiter ? null : venueID, //this.selectedVenue.venueId,
        clauseId: this.hideFieldsForRecruiter ? null : this.selectedTemplate,
        createdOn: this.checkInterviewSchDataObj.createdOn,
        createdBy: this.checkInterviewSchDataObj.createdBy,
        // iwpInterviewId: this.checkInterviewSchDataObj.interviewActivity.iwpInterviewId ? this.checkInterviewSchDataObj.interviewActivity.iwpInterviewId : null
      };
      this.editInterviewActivity(obj);
    } else {
      // console.log(this.selectedVenue.venueId);
      const objS: ISaveInterviewActivity = {
        applicationIds: this.candidateApplicationIds,
        processID: this.checkInterviewSchDataObj.processId,
        activityID: this.checkInterviewSchDataObj.activityId,
        notes: this.notes,
        startDate: this.startDate,
        endDate: this.startDate,
        startTime: this.hideFieldsForRecruiter ? null : this.startTime,
        endTime: this.endTime,
        venueId: this.hideFieldsForRecruiter ? null : venueID, //this.selectedVenue.venueId,
        // statusId: this.checkInterviewSchDataObj.statusId,
        clauseId: this.hideFieldsForRecruiter ? null : this.selectedTemplate,
      };
      console.log(objS);
      console.log(this.checkInterviewSchDataObj.interviewActivity);
      this.saveInterviewActivity(objS);
    }
    this.showMoreLess();
    // this.refreshcandiates.emit("true");
  }

  saveInterviewActivity(obj: ISaveInterviewActivity) {
    console.log('inside saveIntaCtivity');
    console.log(this.selectedTemplate);
    console.log(obj);
    let precheck;
    if (obj.startDate != '') {
      console.log('radhika');
      this.interviewService.saveInterviewActivity(obj).subscribe(
        (res: any) => {
          console.log(res);
          if (res.error && res.error.toLowerCase() === 'failure') {
            precheck = false;
            const data = {
              msg: res.message,
              isSuccess: 'error',
            };

            console.log(data);
            this.interviewService.openSnackBar(data, 'danger-snack');
            // this.refreshcandiates.emit("true");
          } else {
            this.mailFlag = true;
            precheck = true;
            this.saveAttachment(this.checkInterviewSchDataObj.applicationId, this.companyHiringType);

            if (this.sendMailCheck == true)
            // && this.mailFlag == true)
            {
              console.log('inside if', this.mailFlag);
              // this.corresActivity.subscribe(data =>{
              this.saveInterviewCorresActivity(
                this.correspondenceDataObj.processId,
                this.correspondenceDataObj.activityId,
                this.candidateApplicationIds,
              );
              // this.corresActivity.saveInterviewCorresActivity(this.correspondenceDataObj.processId, this.correspondenceDataObj.activityId, this.candidateApplicationIds);
              // })
            } else {
              if (!this.ifCoupled) {
                this.refreshcandiates.emit('true');
              }
            }
            console.log('attachmnet called already');

            const data = {
              msg: res.message,
              isSuccess: 'created',
            };
            this.interviewService.openSnackBar(data, 'success-snack');
          }
        },
        (err) => {
          console.log(err);
          const data = {
            msg: 'Some error occurred',
            isSuccess: false,
          };
          this.interviewService.openSnackBar(data, 'danger-snack');
        },
      );
      console.log('sendmailcheck-->', this.sendMailCheck, 'mailflag-->', this.mailFlag, 'precheck--', precheck);
      // if (this.sendMailCheck == true)
      // // && this.mailFlag == true)
      // {
      //   console.log("inside if");
      //   this.corresActivity.saveInterviewCorresActivity(this.correspondenceDataObj.processId, this.correspondenceDataObj.activityId, this.candidateApplicationIds);
      // }
    }
  }

  editInterviewActivity(editObj: InterviewActivity) {
    console.log('inside edit');

    this.interviewService.editInterviewActivity(editObj).subscribe(
      (res: any) => {
        console.log('response' + res);

        this.saveAttachment(this.checkInterviewSchDataObj.applicationId, this.companyHiringType);
        if (this.sendMailCheck == true)
        // && this.mailFlag == true)
        {
          console.log('inside if', this.mailFlag);
          // this.corresActivity.subscribe(data =>{
          this.saveInterviewCorresActivity(editObj.processID, editObj.activityID, editObj.applicationIds);
          // this.corresActivity.saveInterviewCorresActivity(this.correspondenceDataObj.processId, this.correspondenceDataObj.activityId, this.candidateApplicationIds);
          // })
        }
        // this.getActivity();
        const data = {
          msg: 'Data Updated Successfully !!! ',
          isSuccess: 'created',
        };

        this.interviewService.openSnackBar(data, 'success-snack');
      },
      (err) => {
        const data = {
          msg: err,
          isSuccess: false,
        };
        this.interviewService.openSnackBar(data, 'danger-snack');
      },
    );
    this.dialogRef.close();
  }

  getActivity(obj: CheckInterviewSchDataObj) {
    // obj.createdOn

    console.log('indide get activity function in component');
    this.interviewService
      .getInterviewActivity(obj.applicationId, obj.activityId, obj.processId, obj.createdOn)
      .subscribe((response) => {
        this.checkInterviewSchDataObj.interviewActivity = response;
        console.log('getInterviewActivityComponent', response);
        this.dataInitialization(response);
      });
  }

  dataInitialization(interviewactivityObj: any) {
    if (interviewactivityObj == null) {
      this.notes = '';
      this.startDate = '';
      this.endDate = '';
      this.isDeleteDisable = true;
    } else {
      // this.associateService.recruiterActivity.subscribe(res=>
      //   {
      //     console.log("response of recruiterativity--",res)
      //     this.interviewService.getCorrespondenceActivity(this.checkInterviewSchDataObj.applicationId, res.activityId, res.processId,this.checkInterviewSchDataObj.createdOn).subscribe(data=>
      //       {
      //         console.log("getcorres--",data)
      //       })

      //   })

      this.notes = interviewactivityObj.notes;
      this.startDate = interviewactivityObj.startDate;
      // this.startTime=interviewactivityObj.startTime;
      if (this.companyHiringType === '2' && this.checkInterviewSchDataObj.activityId === 400104) {
        this.parseTestScoreData();
      }

      let startTime = String(interviewactivityObj.startTime);
      if (startTime.length < 4) {
        startTime = '0' + startTime;
      }
      console.log('append 0 to start time---', startTime);
      // let startTime = String(interviewactivityObj.startTime);
      startTime = startTime[0] + startTime[1] + ':' + startTime[2] + startTime[3];
      console.log('startime----', startTime);

      this.startTime = startTime;
      this.endDate = interviewactivityObj.endDate;
      console.log('selectd venue', interviewactivityObj);
      if (!this.venueHide) {
        this.VenueId = Number(interviewactivityObj.venue.venueID);
        console.log('venue id', this.VenueId);
        this.selectedVenue = this.venue.find((v) => Number(v.venueId) === Number(this.VenueId));
        console.log('venue list', this.venue);
        console.log();
        console.log('selectd venue', this.selectedVenue);
      }
      // time
      this.timeModifiedOn = interviewactivityObj.modifiedOn;
      this.isDeleteDisable = false;
      this.selectedTemplate = interviewactivityObj.clauseMasterlist.clauseId;
      console.log('templateid--', this.selectedTemplate);
      this.interviewDate = this.datePipe.transform(new Date(this.startDate), 'dd-MM-yyyy');
      this.interviewTime = this.startTime;
      const index = this.templateData.findIndex((item) => item.clauseid === this.selectedTemplate);
      this.selectedClauseIndex = index;
    }
  }
  deleteactivity() {}

  receiveFileOutput(filedata) {
    this.fileData = filedata['fileMerge1'];
    console.log(this.fileData);
    this.deletedFile = filedata['deletedFile1'];
  }

  saveAttachment(genericId, companyHiringTypeId) {
    console.log('save attachment');

    if (this.deletedFile && this.deletedFile.length > 0) {
      this.deletedFile.forEach((file) => {
        this.fileService.deleteFile(file.fileID).subscribe(
          (_res) => {},
          (_err) => {},
        );
      });
    }
    const activityId: any = this.checkInterviewSchDataObj.activityId;
    const fd = new FormData();
    fd.append('objectId', genericId);
    fd.append('objectType', 'AP');
    fd.append('attachmentId', '2');
    fd.append('companyHiringTypeId', companyHiringTypeId);
    fd.append('activityId', activityId);
    if (this.fileData && this.fileData.length > 0) {
      this.fileData.forEach((file) => {
        fd.append('file[' + file.name + ']', file);
      });
      this.fileService.upload(fd).subscribe(
        (_res) => {},
        (_err) => {
          const data = {
            msg: 'Some error Occurred',
            isSuccess: false,
          };
          this.interviewService.openSnackBar(data, 'danger-snack');
        },
      );
    }
  }

  parseTestScoreData() {
    let testScoreString = '';

    if (this.checkInterviewSchDataObj && this.checkInterviewSchDataObj.interviewActivity) {
      testScoreString = this.checkInterviewSchDataObj.interviewActivity.notes || '';
    } else {
      testScoreString = this.notes || '';
    }

    console.log('Parsing test score string:', testScoreString);

    if (testScoreString && testScoreString.includes('OBTAINED MARKS')) {
      const scores = [];
      let englishPassage = '';
      let totalMarks = '';

      // Extract English Passage first (it has a different format)
      const passageMatch = testScoreString.match(
        /ENGLISH WRITTEN TEST PASSAGE\s*:\s*(.+?)(?=TOTAL OBTAINED MARKS|$)/is,
      );
      if (passageMatch) {
        englishPassage = passageMatch[1].trim();
      }

      // Extract all test scores with OBTAINED MARKS
      const testRegex = /([A-Z\s]+?ABILITY TEST|ENGLISH GRAMMAR TEST)\s+OBTAINED MARKS\s*:\s*(\d+)/gi;
      let match;
      while ((match = testRegex.exec(testScoreString)) !== null) {
        scores.push({
          test: match[1].trim() + ' OBTAINED MARKS',
          marks: match[2].trim(),
        });
      }

      // Extract total marks
      const totalMatch = testScoreString.match(/TOTAL OBTAINED MARKS\s*:\s*(\d+)/i);
      if (totalMatch) {
        totalMarks = totalMatch[1];
      }

      if (scores.length > 0) {
        this.testScoreData = {
          heading: 'Bulk Candidate Test Score',
          scores: scores,
          totalMarks: totalMarks,
          englishPassage: englishPassage,
        };
        console.log('Parsed test score data:', this.testScoreData);
        this.isNotesInExpectedFormat = true;
      }
    }
  }
}
